import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IPlanData } from 'src/app/interfaces/clients/client.interface';
import { ClientsService } from 'src/app/services/clients.service';
import { TranslateModule } from '@ngx-translate/core';
import { TableModalAreaComponent } from "src/app/components/modal-area/modal-area.component";
import { AlertService } from 'src/app/services/alert.service';
import { UploadService } from 'src/app/services/upload.service';

@Component({
  selector: 'app-clients-info',
  standalone: true,
  imports: [
    TranslateModule,
    TableModalAreaComponent
],
  templateUrl: './clients-info.component.html',
  styleUrl: './clients-info.component.scss'
})
export class ClientsInfoComponent implements OnInit{
  private readonly clientsService = inject(ClientsService);
  public data = inject<{id: string;}>(MAT_DIALOG_DATA);
  private readonly uploadService = inject(UploadService);
  private readonly alertService = inject(AlertService);

  clientInfo: IPlanData = {} as IPlanData;

  ngOnInit(): void {
    this.getClientInfo();
  }

  handleClickDownloadContract() {
    this.uploadService.downloadFileNoSpinner(this.data.id).subscribe({
      next: (response) => {
        const blob = response.body;

        if (!blob) {
          return;
        }

        const fileName = 'contrato';
        this.downloadFromBlob(blob, fileName);
      },
      error: (error) => {
        this.alertService.show({
          type: 'error',
          subtitle: error?.error?.message || 'CLIENTS_INFO.DOWNLOAD_ERROR'
        });
      },
    });
  }

  private downloadFromBlob(blob: Blob, fileName: string) {
    const url = globalThis.URL.createObjectURL(blob);
    const anchor = document.createElement('a');

    anchor.href = url;
    anchor.download = fileName;

    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    globalThis.URL.revokeObjectURL(url);
  }

  getClientInfo() {
    this.clientsService.getCompanyPlans(this.data.id).subscribe((res) => {
      this.clientInfo = res.data;
    });
  }
}
